<template>
<div class="d-flex justify-center align-center mt-10">
    <v-sheet v-if="apps" color="transparent" class="d-flex justify-space-around flex-wrap">
      <v-card class="mb-2 mx-1" :color="`#e1e1e1`" flat rounded="xl" min-width="350" height="100%" v-for="section in apps" :key="section['Раздел']">
        <template v-slot:prepend v-if="section['Разделicon']">
          <v-avatar color="white">
            <v-icon :icon="['fas', section['Разделicon']]" />
          </v-avatar>
        </template>
        <template v-slot:append v-if="section['РазделНаименование']">
          <span class="font-weight-bold">{{ section['РазделНаименование'] }}</span>
        </template>
        <template v-slot:text v-if="section['Кнопки'] && section['Кнопки'].length > 0">
          <template v-for="b in section['Кнопки']" :key="b">
            <v-btn v-if="b.enabled" flat rounded="xl" block class="mb-2" v-on:click="$router.push({ path: b.address })">
              {{ b.name }}
            </v-btn>

            <v-btn v-else flat rounded="xl" block class="mb-2" style="opacity: 0.3; cursor: not-allowed">
              {{ b.name }}
              <v-tooltip
                  v-if="b.reason"
                  activator="parent"
                  location="start"
              >{{ b.reason }}</v-tooltip>
            </v-btn>
          </template>
        </template>
      </v-card>

<!--      <v-row >
        <v-col cols="12" xl="4" md="6" sm="12" >
          <v-card :color="`#e1e1e1`" flat rounded="xl" height="100%">
            <template v-slot:prepend v-if="section['Разделicon']">
              <v-avatar color="white">
                <v-icon :icon="['fas', section['Разделicon']]" />
              </v-avatar>
            </template>
            <template v-slot:append v-if="section['РазделНаименование']">
              <span class="font-weight-bold">{{ section['РазделНаименование'] }}</span>
            </template>
            <template v-slot:text v-if="section['Кнопки'] && section['Кнопки'].length > 0">
              <template v-for="b in section['Кнопки']" :key="b">
                <v-btn v-if="b.enabled" flat rounded="xl" block class="mb-2" v-on:click="$router.push({ path: b.address })">
                  {{ b.name }}
                </v-btn>

                <v-btn v-else flat rounded="xl" block class="mb-2" style="opacity: 0.3; cursor: not-allowed">
                  {{ b.name }}
                  <v-tooltip
                      v-if="b.reason"
                      activator="parent"
                      location="start"
                  >{{ b.reason }}</v-tooltip>
                </v-btn>
              </template>
            </template>
          </v-card>
        </v-col>
      </v-row>-->
    </v-sheet>
  </div>
</template>

<script>
import { TokenGUIDStore } from "@/store/global/SessionStore";
import { AppsStore } from "@/store/AppsList";

export default {
  name: 'HomeView',
  computed: {
    session_token: {
      get() {
        return TokenGUIDStore().get()
      },
      set(value) {
        TokenGUIDStore().set(value)
      }
    },
    apps: {
      get() {
        return AppsStore().get()
      },
      set(value) {
        AppsStore().set(value)
      }
    }
  }
}
</script>
